export default "__VITE_ASSET__CNH22Awg__"